import api from "./axios";

export default class API {
    
  // POST

  //register
  static async register(formdata) {
    return api.post("/register", formdata).then(res => res.data);
  }

  //resend confirmation email
  static async resend_email_confirmation(info) {
    return api.post('/resend_email_confirmation', info).then(res => res.data)
  }

  //login
  static async login(formdata) {
    return api.post("/login", formdata).then(res => res.data);
  }

  //add student
  static async add_student(info) {
    return api.post("/add_student", info, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }).then(res => res.data);
  }

  //add guardian
  static async add_guardian(info) {
    return api.post("/add_guardian", info).then(res => res.data);
  }

  //upload student photo
  static async upload_student_photo(info) {
    return api.post("/upload_student_photo", info).then(res => res.data);
  }

  //run_promotion
  static async run_promotion(info) {
    return api.post("/run_promotion", info).then(res => res.data);
  }

  //create_session
  static async create_session(info) {
    return api.post("/create_session", info).then(res => res.data);
  }

  static async set_current_session(info) {
    return api.post("/set_current_session", info).then(res => res.data);
  }

  static async set_current_term(info) {
    return api.post("/set_current_term", info).then(res => res.data);
  }

  static async add_arm(info) {
    return api.post("/add_arm", info).then(res => res.data);
  }

  static async generate_student_id_card(info) {
    return api.post("/generate_student_id_card", info, {responseType: 'blob'}).then(res => res.data);
  }

  static async generate_batch_id_cards(info) {
    return api.post("/generate_batch_id_cards", info, {responseType: 'blob'}).then(res => res.data);
  }

  static async set_teacher_assignments(info) {
    return api.post("/set_teacher_assignments", info).then(res => res.data);
  }

  static async save_attendance(info) {
    return api.post("/save_attendance", info).then(res => res.data);
  }

  static async add_holiday(info) {
    return api.post("/add_holiday", info).then(res => res.data);
  }

  static async add_fee_type(info) {
    return api.post("/add_fee_type", info).then(res => res.data);
  }

  static async add_fee_structure(info) {
    return api.post("/add_fee_structure", info).then(res => res.data);
  }

  static async generate_invoices(info) {
    return api.post("/generate_invoices", info).then(res => res.data);
  }

  static async record_payment(info) {
    return api.post("/record_payment", info).then(res => res.data);
  }

  static async add_payment_channel(info) {
    return api.post("/add_payment_channel", info).then(res => res.data);
  }

  static async add_subject(info) {
    return api.post("/add_subject", info).then(res => res.data);
  }

  static async save_class_subjects(info) {
    return api.post("/save_class_subjects", info).then(res => res.data);
  }

  static async add_assessment_type(info) {
    return api.post("/add_assessment_type", info).then(res => res.data);
  }

  static async add_grading_scale(info) {
    return api.post("/add_grading_scale", info).then(res => res.data);
  }

  static async save_result_scores(info) {
    return api.post("/save_result_scores", info).then(res => res.data);
  }

  static async submit_batch_for_review(info) {
    return api.post("/submit_batch_for_review", info).then(res => res.data);
  }

  static async publish_result_batch(info) {
    return api.post("/publish_result_batch", info).then(res => res.data);
  }

  static async save_student_traits(info) {
    return api.post("/save_student_traits", info).then(res => res.data);
  }

  static async create_trait(info) {
    return api.post("/create_trait", info).then(res => res.data);
  }

  static async save_class_remark(info) {
    return api.post("/save_class_remark", info).then(res => res.data);
  }

  static async create_remark_scale(info) {
    return api.post("/create_remark_scale", info).then(res => res.data);
  }

  static async save_report_fee_mapping(info) {
    return api.post("/save_report_fee_mapping", info).then(res => res.data);
  }

  static async generate_report_cards_pdf(info) {
    return api.post("/generate_report_cards_pdf", info, {
      responseType: 'blob' // <-- CRITICAL: Tells axios to treat the response as a file, not JSON
    }).then(res => res.data);
  }

  static async generate_annual_report_cards_pdf(info) {
    return api.post("/generate_annual_report_cards_pdf", info, {
      responseType: 'blob'
    }).then(res => res.data);
  }

  static async generate_default_classes(info) {
    return api.post("/generate_default_classes", info).then(res => res.data);  
  }

  static async add_class(info) {
    return api.post("/add_class", info).then(res => res.data);  
  }

  static async swap_class_order(info) {
    return api.post("/swap_class_order", info).then(res => res.data);  
  }

  static async create_announcement(info) {
    return api.post("/create_announcement", info).then(res => res.data);  
  }

  static async send_message_to_guardian(info) {
    return api.post("/send_message_to_guardian", info).then(res => res.data);  
  }

  static async send_reset_pass_email(info) {
    return api.post("/send_reset_pass_email", info).then(res => res.data);  
  }

  static async reset_password(info) {
    return api.post("/reset_password", info).then(res => res.data);  
  }

  static async bulk_upload_students(formData) {
    return api.post("/bulk_upload_students", formData).then(res => res.data);
  }

  static async bulk_upload_photos(formData) {
    return api.post("/bulk_upload_photos", formData).then(res => res.data);
  }
  
  static async logout() {
    return api.post("/logout").then(res => res.data);
  }
   
  // GET

  static async email_verification(id) {
    return api.get(`/confirm_email/${id}`).then(res => res.data)
  }

  static async fetch_admin() {
    return api.get("/fetch_admin").then(res => res.data);
  }

  static async fetch_students(params) {
    return api.get("/fetch_students", { params }).then(res => res.data);
  }

  static async fetch_sessions() {
    return api.get("/fetch_sessions").then(res => res.data);
  }

  static async fetch_classes() {
    return api.get("/fetch_classes").then(res => res.data);
  }

  static async fetch_arms() {
    return api.get("/fetch_arms").then(res => res.data);
  }

  static async get_student(id) {
    return api.get(`/get_student/${id}`).then(res => res.data);
  }

  static async get_class_for_promotion(class_id) {
    return api.get(`/get_class_for_promotion/${class_id}`).then(res => res.data);
  }

  static async get_sessions_with_terms() {
    return api.get(`/get_sessions_with_terms`).then(res => res.data);
  }

  static async get_class_for_id_cards(class_id) {
    return api.get(`/get_class_for_id_cards/${class_id}`).then(res => res.data);
  }

  static async get_staff_list() {
    return api.get("/get_staff_list").then(res => res.data);
  }

  static async get_teacher_assignments(teacher_id) {
    return api.get(`/get_teacher_assignments/${teacher_id}`).then(res => res.data);
  }
 
  static async get_roster_for_attendance(info) {
    return api.get(`/get_roster_for_attendance`, { params: info }).then(res => res.data);
  }

  static async get_attendance_summary(info) {
    return api.get(`/get_attendance_summary`, { params: info }).then(res => res.data);
  }

  static async get_holidays(info) {
    return api.get(`/get_holidays`, { params: info }).then(res => res.data);
  }

  static async fetch_fee_types() {
    return api.get("/fetch_fee_types").then(res => res.data);
  }

  static async fetch_fee_structures(params) {
    return api.get("/fetch_fee_structures", {params}).then(res => res.data);
  }

  static async get_fee_structure(id) {
    return api.get(`/get_fee_structure/${id}`).then(res => res.data);
  }

  static async fetch_invoices(params) {
    return api.get("/fetch_invoices", {params})
  }

  static async get_invoice_detail(id) {
    return api.get(`/get_invoice_detail/${id}`).then(res => res.data);
  }

  static async get_payment_channels() {
    return api.get('get_payment_channels').then(res => res.data)
  }

  static async get_student_unpaid_invoices(id) {
    return api.get(`/get_student_unpaid_invoices/${id}`).then(res => res.data);
  }

  static async search_students_for_payment(search) {
    return api.get(`/search_students_for_payment`, { params: { search } }).then(res => res.data);
  }

  static async fetch_collections_report(start_date, end_date) {
    return api.get('fetch_collections_report', { params: { start_date, end_date } }).then(res => res.data)
  }

  static async fetch_outstanding_balances_report(params) {
    return api.get('fetch_outstanding_balances_report', { params }).then(res => res.data)
  }

  static async fetch_termly_revenue_summary(params) {
    return api.get('fetch_termly_revenue_summary', { params }).then(res => res.data)
  }

  static async fetch_subjects(params) {
    return api.get('fetch_subjects', { params }).then(res => res.data)
  }

  static async fetch_all_subjects_with_assignments(params) {
    return api.get(`fetch_all_subjects_with_assignments`, { params }).then(res => res.data)
  }

  static async fetch_grading_scales() {
    return api.get('/fetch_grading_scales').then(res => res.data)
  }

  static async fetch_assessment_types() {
    return api.get('/fetch_assessment_types').then(res => res.data)
  }

  static async fetch_result_batch_and_scores(params) {
    return api.get('/fetch_result_batch_and_scores', {params}).then(res => res.data)
  }

  static async fetch_batch_audit_logs(params) {
    return api.get('fetch_batch_audit_logs', {params}).then(res => res.data)
  }

  static async fetch_student_traits(params) {
    return api.get('fetch_student_traits', {params}).then(res => res.data)
  }

  static async fetch_traits(params) {
    return api.get('fetch_traits', {params}).then(res => res.data)
  }

  static async fetch_remark_scales() {
    return api.get('fetch_remark_scales').then(res => res.data)
  }

  static async fetch_class_remark(params) {
    return api.get('/fetch_class_remark', {params}).then(res => res.data)
  }

  static async fetch_class_averages(params) {
    return api.get('/fetch_class_averages', {params}).then(res => res.data)
  }

  static async get_report_fee_mapping() {
    return api.get('/get_report_fee_mapping').then(res => res.data)
  }

  static async fetch_report_card_data(params) {
    return api.get('/fetch_report_card_data', {params}).then(res => res.data)
  }

  static async get_class_remark(params) {
    return api.get('/get_class_remark', {params}).then(res => res.data)
  }

  static async fetch_dashboard_summary() {
    return api.get('/fetch_dashboard_summary',).then(res => res.data)
  }

  static async fetch_broadsheet(params) {
    return api.get('/fetch_broadsheet', {params}).then(res => res.data)
  }

  static async fetch_announcements(params) {
    return api.get("/fetch_announcements", { params }).then(res => res.data);
  }

  static async get_developer_info() {
    return api.get("/get_developer_info").then(res => res.data);
  }

  static async fetch_results_collation_status(params) {
    return api.get("/fetch_results_collation_status", { params }).then(res => res.data);
  }
  
  static async fetch_settings() {
    return api.get("/fetch_settings").then(res => res.data);
  }

  // PATCH
  static async update_student_class(info) {
    return api.patch("/update_student_class", info).then(res => res.data)
  }

  static async update_student_status(info) {
    return api.patch("/update_student_status", info).then(res => res.data)
  }

  static async update_student(info) {
    return api.patch("/update_student", info).then(res => res.data)
  }

  static async update_guardian(info) {
    return api.patch("/update_guardian", info).then(res => res.data)
  }

  static async set_primary_guardian(info) {
    return api.patch("/set_primary_guardian", info).then(res => res.data)
  }

  static async update_term(info) {
    return api.patch("/update_term", info).then(res => res.data);
  }

  static async update_school_settings(info) {
    return api.patch("/update_school_settings", info).then(res => res.data);
  }

  static async update_staff_role(info) {
    return await api.patch("/update_staff_role", info)
  }

  static async update_staff_status(info) {
    return await api.patch("/update_staff_status", info)
  }

  static async update_holiday(id, info) {
    return await api.patch(`/update_holiday/${id}`, info).then(res => res.data);
  }

  static async update_fee_type(id, info) {
    return await api.patch(`/update_fee_type/${id}`, info).then(res => res.data);
  }

  static async update_fee_structure(id, info) {
    return await api.patch(`/update_fee_structure/${id}`, info).then(res => res.data);
  }

  static async update_payment_channel(id, info) {
    return await api.patch(`/update_payment_channel/${id}`, info).then(res => res.data);
  }

  static async update_subject(id, info) {
    return await api.patch(`/update_subject/${id}`, info).then(res => res.data);
  }

  static async update_assessment_type(id, info) {
    return await api.patch(`/update_assessment_type/${id}`, info).then(res => res.data);
  }

  static async update_grading_scale(id, info) {
    return await api.patch(`/update_grading_scale/${id}`, info).then(res => res.data);
  }

  static async admin_override_score(info) {
    return api.patch("/admin_override_score", info).then(res => res.data);
  }

  static async revert_batch_to_draft(info) {
    return api.patch("/revert_batch_to_draft", info).then(res => res.data);
  }

  static async toggle_trait_status(info) {
    return api.patch("/toggle_trait_status", info).then(res => res.data);
  }

  static async update_trait(info) {
    return api.patch("/update_trait", info).then(res => res.data);
  }

  static async update_remark_scale(info) {
    return api.patch("/update_remark_scale", info).then(res => res.data);
  }

  static async update_admin_info(info) {
    return api.patch("/update_admin_info", info).then(res => res.data);
  }

  static async update_system_info(info) {
    return api.patch("/update_system_info", info).then(res => res.data);
  }

  static async update_admin_pass(info) {
    return api.patch("/update_admin_pass", info).then(res => res.data);
  }


  //DELETE
  static async delete_user(info) {
    return api.delete("/delete_user", info).then(res => res.data)
  }

  static async delete_guardian(info) {
    return api.delete("/delete_guardian", info).then(res => res.data)
  }

  static async delete_arm(info) {
    return api.delete("/delete_arm", info).then(res => res.data)
  }

  static async delete_staff(info) {
    return api.delete("/delete_staff", info).then(res => res.data)
  }

  static async delete_holiday(id) {
    return await api.delete(`/delete_holiday/${id}`).then(res => res.data);
  }

  static async delete_fee_type(id) {
    return await api.delete(`/delete_fee_type/${id}`).then(res => res.data);
  }

  static async delete_fee_structure(id) {
    return await api.delete(`/delete_fee_structure/${id}`).then(res => res.data);
  }

  static async delete_payment_channel(id) {
    return await api.delete(`/delete_payment_channel/${id}`).then(res => res.data);
  }

  static async delete_subject(id) {
    return await api.delete(`/delete_subject/${id}`).then(res => res.data);
  }

  static async delete_assessment_type(id) {
    return await api.delete(`/delete_assessment_type/${id}`).then(res => res.data);
  }

  static async delete_grading_scale(id) {
    return await api.delete(`/delete_grading_scale/${id}`).then(res => res.data);
  }

  static async delete_remark_scale(info) {
    return await api.delete(`/delete_remark_scale`, info).then(res => res.data);
  }

  static async delete_class(info) {
    return await api.delete(`/delete_class`, info).then(res => res.data);
  }

  static async delete_announcement(info) {
    return await api.delete(`/delete_announcement`, info).then(res => res.data);
  }

}
